import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { BASIC_BUTTON_COLOR_NEUTRAL, BASIC_BUTTON_TYPE_FLAT_TRANSPARENT } from '@divvy-web/skylab.basicbutton'

import { LogoutButton } from '@sputnik/components'
import BillBrandLogo from '@sputnik/components/BillBrandLogo'
import HelpButton from '@sputnik/components/HelpButton'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

const DashboardHeader = () => {
  const [getClassName] = useNameFormatter('DashboardHeader')
  const { track } = useWebTracking()

  return (
    <div className={styles[getClassName('')]}>
      <BillBrandLogo />
      <div className={styles[getClassName('actions')]}>
        <div className={styles[getClassName('help-icon')]}>
          <HelpButton />
        </div>
        <div className={styles[getClassName('vertical-divider')]} />
        <LogoutButton
          buttonType={BASIC_BUTTON_TYPE_FLAT_TRANSPARENT}
          color={BASIC_BUTTON_COLOR_NEUTRAL}
          onClick={() => {
            track('se_signup__application_dashboard_home_log_out__fired')
          }}
        />
      </div>
    </div>
  )
}

export default DashboardHeader
